const completed = status => String(status || '').toLowerCase() === 'completed';

// The first history response establishes a baseline, rather than downloading
// old transcripts. Later completions enter a small queue and get one attempt.
export function createResultPrefetchQueue() {
  let previous = null;
  const pending = new Set();
  return {
    observe(files, { seed = false } = {}) {
      const next = new Map(files.map(file => [file.id, file.status]));
      if (previous && !seed) {
        for (const file of files) {
          if (completed(file.status) && !completed(previous.get(file.id)) && pending.size < 3) pending.add(file.id);
        }
      }
      for (const id of pending) if (!next.has(id) || !completed(next.get(id))) pending.delete(id);
      previous = next;
    },
    next(cache = {}) {
      for (const id of pending) {
        pending.delete(id);
        if (!cache[id]) return id;
      }
      return null;
    },
  };
}
